import { MarkerType } from '@xyflow/react'

export const API = `${import.meta.env.VITE_API_URL ?? ''}/api/flows`
export const MAX_HISTORY = 50
export const TRIGGER_ID  = '__trigger__'

export const EDGE_NORMAL        = { stroke: '#94A3B8', strokeWidth: 1.5 }
export const EDGE_OPTION        = { stroke: '#D4A017', strokeWidth: 1.5 }
export const EDGE_FALLBACK      = { stroke: '#EF4444', strokeWidth: 1.5, strokeDasharray: '6 3' }
export const EDGE_UP_TO_DATE    = { stroke: '#F59E0B', strokeWidth: 1.5, strokeDasharray: '6 3' }
export const EDGE_TRIGGER_STYLE = { stroke: '#25D366', strokeWidth: 2 }

export const MARKER_NORMAL     = { type: MarkerType.ArrowClosed, color: '#94A3B8', width: 14, height: 14 }
export const MARKER_OPTION     = { type: MarkerType.ArrowClosed, color: '#D4A017', width: 14, height: 14 }
export const MARKER_FALLBACK   = { type: MarkerType.ArrowClosed, color: '#EF4444', width: 14, height: 14 }
export const MARKER_UP_TO_DATE = { type: MarkerType.ArrowClosed, color: '#F59E0B', width: 14, height: 14 }
export const MARKER_TRIGGER    = { type: MarkerType.ArrowClosed, color: '#25D366', width: 14, height: 14 }
